import toast from "react-hot-toast";
import axiosSetup from "../utils/axiosSetup";
import { RegularizationPayload } from "../models/regularize.model";

interface ApproveRejectPayload {
  applicationId: string;
  action: "approved" | "rejected";
}

export const approveOrRejectRegularizationApi = async (
  payload: ApproveRejectPayload
) => {
  try {
    const response = await axiosSetup.post(
      "/regularize/manager/approve-reject",
      payload
    );
    toast.success(`Regularization request ${payload.action} successfully`);
    return response.data.data;
  } catch (error: any) {
    console.error("Approve/Reject regularization error:", error);
    toast.error(`Failed to ${payload.action} regularization request`);
    throw error;
  }
};

export const submitRegularizationApi = async (
  payload: RegularizationPayload
) => {
  try {
    const response = await axiosSetup.post("/regularize", payload);
    return response.data;
  } catch (error) {
    console.error("Submit attendance regularization error:", error);
    throw error;
  }
};

export const fetchAllRegularizationApplicationsApi = async () => {
  try {
    const response = await axiosSetup.get("/regularize/all-applications");
    return response.data.data;
  } catch (error) {
    console.error("Fetch regularization applications error:", error);
    toast.error("Failed to fetch regularization applications");
    throw error;
  }
};

export const withdrawRegularizationApi = async (applicationId: string) => {
  try {
    const response = await axiosSetup.post(`/regularize/withdraw`, {
      applicationId,
    });
    return response.data;
  } catch (error) {
    console.error("Withdraw regularization error:", error);
    toast.error("Failed to withdraw regularization");
    throw error;
  }
};

export const createOrUpdateManualOverrideAPI = async (data: {
  userId: string;
  date: string;
  session1Status: "Present" | "Absent" ;
  session2Status: "Present" | "Absent" ;
  remarks?: string
}) => {
  try {
    const response = await axiosSetup.post("/regularize/manager/manual-override", data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const getUserManualOverridesAPI = async (userId: string) => {
  try {
    const response = await axiosSetup.get(`/regularize/manual-overrides?userId=${userId}`);
    return response.data.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

